import { AppsFeatureKey, AppsFeatureState } from './app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const appsState =
  createFeatureSelector<AppsFeatureState>(AppsFeatureKey);

export const selectListOfApps = createSelector(appsState, ({ list }) => list);

export const selectTop5Apps = createSelector(appsState, ({ list }) => {
  if (list == null) return [];
  return list.data.length > 5 ? list.data.slice(0, 5) : list.data;
});

export const selectAppsCount = createSelector(
  appsState,
  ({ list }) => list?.meta.count
);

export const selectAppLoadingStatus = createSelector(
  appsState,
  ({ status }) => status
);

export const selectCurrentAppWholeData = createSelector(
  appsState,
  ({ currentApp }) => currentApp
);

export const selectCurrentAppPaymentInfo = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.paymentInfo
);

export const selectCurrentAppDefaultCurrency = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.paymentInfo.defaultCurrency
);

export const selectCurrentAppLanguageList = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.languageList
);

export const selectCurrentAppSupportedLanguageList = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.languageList.supportedLanguages
);

export const selectCurrentAppDefaultLanguage = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.languageList.defaultLanguage
);

export const selectCurrentAppDetails = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.appDetails
);

export const selectSupportedSalesChannelOfCurrentApp = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.supportedSalesChannelList
);

export const selectWebSettingsOfCurrentApp = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.webSettings
);

export const selectAppGoogleAnalyticsData = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.webSettings?.gaId
);

export const selectAppGoogleAnalyticsActivnessStatus = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.webSettings?.gaId !== undefined
);

export const selectAppGoogleTagManagersData = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.webSettings.gtmId
);

export const selectAppGoogleTagManagersActivnessStatus = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.webSettings?.gtmId !== undefined
);

export const selectAppWebhookActivness = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.webSettings.webHook
);

export const selectAppGuestShoppingActivness = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.webSettings.guestShopping
);

export const selectCurrentAppIsAppSumoApp = createSelector(
  appsState,
  ({ currentApp }) => currentApp?.appDetails.isAppsumo
);

export const selectPrimitiveStoreData = createSelector(
  appsState,
  ({ primitiveData }) => primitiveData
);
